module.exports = __webpack_public_path__ + "dist/media/logo--hu.cd03093e.svg";